

export const isDev = () => {
  return ['localhost', 'staging'].some(keyword => new RegExp(keyword).test(window.location.href));
}